import { Group, Text } from '@mantine/core';

import { Author } from '@feature/utils';

interface AuthorCardListProps {
  authors: Author[];
}

export function AuthorCardList(props: AuthorCardListProps) {
  const { authors } = props;
  return (
    <Group gap="xs">
      {authors.map((author, index) => (
        <Group
          key={author.id}
          mb="1px"
          gap="xs"
        >
          <Text size="sm">
            {author.userName}
            {index !== authors.length - 1 ? ',' : ''}
          </Text>
        </Group>
      ))}
    </Group>
  );
}
